import { CustomerModel } from './customer.model'
import { OrderServiceModel } from './order.model'

export type GiftCardModel = {
  id: number
  code: string
  amount: number
  dateTime: number
  expiryDate: number
  status: GiftCardStatus
  paymentStatus: GiftCardPaymentStatus
  name: string
  phoneNumber: string
  email: string
  usedDateTime?: number
  staffComment: string
}

export type GiftCardViewModel = GiftCardModel & {
  pin: string
  usedForOrder?: {
    id: string
    mainService: OrderServiceModel
    customer: CustomerModel
  }
}

export type GiftCardCreateModel = {
  name: string
  phoneNumber: string
  email: string
  amount: number
  staffComment: string
}

export enum GiftCardStatus {
  Created = 'Created',
  Active = 'Active',
  Used = 'Used',
  Expired = 'Expired',
  Cancelled = 'Cancelled'
}

export enum GiftCardPaymentStatus {
  None = 'None',
  Requested = 'Requested',
  Paid = 'Paid',
  Failed = 'Failed'
}
